module.exports = __webpack_public_path__ + "img/lens-174-minus-02.6808dc3d.png";